/* Animations ZNP04 : GSAP (ScrollTrigger, SplitText) + Lenis.
   Le contenu reste visible sans JavaScript. Rien ne bouge dans l'éditeur Shopify ni si le visiteur réduit les animations.
   Moments forts : l'entrée du header (lignes masquées, image dévoilée, lueur orange) et le boîtier qui « diffuse » ses fonctions. */
(() => {
  const root = document.documentElement;
  const release = () => root.classList.remove('znp-motion');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!window.gsap || !window.ScrollTrigger || window.ZNP_DESIGN_MODE) { release(); return; }
  const hasSplit = !!window.SplitText;
  gsap.registerPlugin(ScrollTrigger, ...(hasSplit ? [SplitText] : []));
  window.ZNP_MOTION_READY = true;

  const EASE = 'expo.out';
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // Changement d'onglet : les visuels du nouvel onglet arrivent (fondu seul si animations réduites)
  document.addEventListener('znp:panel', e => {
    const slides = $$('.znp-slide', e.target);
    if (reduce.matches) gsap.fromTo(slides, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.2, overwrite: true });
    else gsap.fromTo(slides, { autoAlpha: 0, y: 18 }, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.05, ease: EASE, overwrite: true });
  });

  if (reduce.matches) { release(); return; }

  // Défilement fluide : ordinateur avec souris ou pavé tactile seulement (le tactile garde le défilement natif)
  let lenis = null;
  const mm = gsap.matchMedia();
  mm.add('(prefers-reduced-motion: no-preference) and (pointer: fine)', () => {
    if (!window.Lenis) return;
    lenis = new Lenis({ autoRaf: false, lerp: 0.1 });
    lenis.on('scroll', ScrollTrigger.update);
    const tick = t => lenis.raf(t * 1000);
    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);
    return () => { gsap.ticker.remove(tick); gsap.ticker.lagSmoothing(500, 33); lenis.destroy(); lenis = null; };
  });

  // Liens d'ancre (#acheter, /#fonctions…) : défilement fluide jusqu'à la section
  document.addEventListener('click', e => {
    const a = lenis && e.target.closest('a[href*="#"]');
    if (!a) return;
    const url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || url.hash.length < 2) return;
    const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    lenis.scrollTo(target); // le décalage sous l'en-tête vient du scroll-padding-top du CSS
    history.pushState(null, '', url.hash);
  });

  // La visionneuse bloque le défilement de la page tant qu'elle est ouverte
  const lb = document.getElementById('znp-lb');
  if (lb) new MutationObserver(() => lenis && (lb.open ? lenis.stop() : lenis.start())).observe(lb, { attributes: true, attributeFilter: ['open'] });

  // Ligne de titre masquée : le texte monte derrière un cache (accents et jambages inclus)
  const maskLines = els => els.map(el => {
    const m = document.createElement('div');
    m.className = 'znp-line-mask';
    el.parentNode.insertBefore(m, el);
    m.appendChild(el);
    return el;
  });

  mm.add({ small: '(max-width: 989px) and (prefers-reduced-motion: no-preference)', large: '(min-width: 990px) and (prefers-reduced-motion: no-preference)' }, ctx => {
    const small = ctx.conditions.small;
    const rise = small ? 22 : 36;
    const undo = []; // écouteurs à retirer quand le format change (téléphone ↔ ordinateur)

    // 0 bis. Header « scène » : la personne ne bouge pas ; au défilement, seul le boîtier s'ouvre (l'écran coulisse
    // sur sa course réelle) et les vrais écrans du produit défilent derrière, en deux rangées opposées
    const scene = document.querySelector('[data-scene]');
    if (scene) {
      const pin = scene.querySelector('.znp-scene__pin');
      const slider = scene.querySelector('.znp-scene__slider');
      const rows = $$('.znp-scene__row', scene);
      const hint = scene.querySelector('.znp-scene__hint');
      const lines = scene.querySelector('.znp-h1 .znp-line-mask') ? $$('.znp-h1 .znp-line-mask > span', scene) : maskLines($$('.znp-h1 > span', scene));
      const SHUT = 48.25; // course de l'écran mesurée sur la photo, en % de sa hauteur
      const [first, ...later] = lines; // « Votre musique. » à l'arrivée ; « traducteur » puis « assistant IA » au défilement
      gsap.set(slider, { y: 0, yPercent: SHUT }); // reprend la main sur la position fermée posée en CSS (sans la doubler)
      gsap.set(later, { yPercent: 115 });

      const tl = gsap.timeline({ defaults: { ease: EASE }, delay: 0.1 });
      // la photo n'est pas animée : elle s'affiche dès son arrivée (image principale, vitesse de la page)
      tl.from(scene.querySelector('.znp-scene__wall'), { autoAlpha: 0, duration: 1.8, ease: 'power2.out' }, 0.3)
        .from(rows, { x: (i) => (i ? -60 : 60), duration: 2.2, ease: 'power3.out' }, 0.3)
        .from(scene.querySelector('.znp-label'), { autoAlpha: 0, y: 10, duration: 0.6 }, 0.2)
        .from(first, { yPercent: 115, duration: 1.2 }, 0.3)
        .from(scene.querySelector('.znp-lead'), { autoAlpha: 0, y: 18, duration: 0.8 }, 0.75)
        .from($$('.znp-hero__btns > *', scene), { autoAlpha: 0, y: 16, duration: 0.7, stagger: 0.08 }, 0.9);
      if (hint) tl.from(hint, { autoAlpha: 0, y: -8, duration: 0.8 }, 1.6);

      // Défilement : chaque ligne du titre arrive à son tour et passe au premier plan (les précédentes s'estompent),
      // pendant que le boîtier s'ouvre ; à la fin, les trois lignes sont pleinement visibles
      const sceneHead = () => { const h = document.querySelector('.znp-head'); return h ? h.offsetHeight : 0; };
      const st = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: { trigger: scene, start: () => 'top ' + sceneHead(), end: () => '+=' + Math.round(window.innerHeight * (small ? 1.3 : 1.7)), pin: pin, scrub: 0.8, invalidateOnRefresh: true }
      });
      st.to(slider, { yPercent: 0, duration: 0.6, ease: 'power2.inOut' }, 0.1);
      // la ligne qui arrive est blanche, même la grise ; elle reprend sa couleur quand les trois sont réunies
      const tint = lines.map(l => getComputedStyle(l).color);
      later.forEach((line, i) => {
        const at = 0.08 + i * 0.32;
        st.fromTo(line, { color: '#fff' }, { yPercent: 0, color: '#fff', duration: 0.2, ease: 'power3.out', immediateRender: false }, at)
          .to(lines.slice(0, i + 1), { opacity: 0.32, duration: 0.14 }, at);
      });
      st.to(lines, { opacity: 1, color: (i) => tint[i], duration: 0.14 }, 0.8);
      if (rows[0]) st.to(rows[0], { xPercent: -12, duration: 1 }, 0);
      if (rows[1]) st.to(rows[1], { xPercent: 12, duration: 1 }, 0);
      if (hint) st.to(hint, { autoAlpha: 0, duration: 0.08 }, 0);
    }

    // 0 ter. Playlist : le lecteur de l'écran du boîtier rejoue la vidéo réelle au défilement.
    // Lecture → morceau suivant → le boîtier s'ouvre (le son passe aux écouteurs) → appuis sur les écouteurs (1, 2, 3).
    // Les états du lecteur (lecture, morceau, étape active) se lisent sur le temps de la frise, à l'aller comme au retour.
    const pl = document.querySelector('[data-pl]');
    if (pl) {
      const q = s => pl.querySelector(s);
      const screen = q('.znp-pl__screen');
      const tracks = $$('.znp-pl__track', pl);
      const steps = $$('.znp-pl__step', pl);
      const [tapL, tapR] = $$('.znp-pl__tap', pl);
      const callL = q('.znp-pl__call--l'), callR = q('.znp-pl__call--r');
      let chips = [];
      try { chips = JSON.parse(q('[data-pl-chips]').textContent || '""').split('|'); } catch (e) { /* bulles vides */ }
      const T = { play: 1.05, next: 2.65, step2: 1.8, step3: 3.5, step4: 6.3, last: 9.75 };
      // étiquette affichée selon le moment : [début, texte] du côté gauche puis droit
      const chipAt = { l: [[0, chips[0]], [8.3, chips[2]]], r: [[0, chips[1]], [9.1, chips[3]]] };
      // « 2 appuis · volume + » : le nombre d'appuis en orange, le geste en blanc dessous
      const setCall = (el, txt = '') => {
        if (!el || el.dataset.txt === txt) return;
        el.dataset.txt = txt;
        const [n, act = ''] = txt.includes(' · ') ? txt.split(' · ') : ['', txt];
        el.querySelector('b').textContent = n;
        el.querySelector('.znp-pl__lbl span').textContent = act.charAt(0).toUpperCase() + act.slice(1);
      };
      // Le bac suit le couvercle : caché quand le boîtier est fermé (le couvercle seul forme un boîtier entier), dévoilé
      // de bas en haut sous le couvercle pendant l'ouverture (découpe). Calculé à chaque image d'après la position réelle
      // du couvercle, donc juste en avançant comme en revenant en arrière
      const slide = q('.znp-pl__slide'), bac = q('.znp-pl__bac');
      let lidAt = '';
      const followLid = () => {
        const r = (34 + 66 * gsap.getProperty(slide, 'yPercent') / 35.44).toFixed(1);
        if (r === lidAt) return;
        lidAt = r;
        bac.style.clipPath = 'inset(' + r + '% 0 0 0 round 9% 9% 0 0 / 4.7% 4.7% 0 0)';
      };
      // à chaque image : ScrollTrigger replace parfois le couvercle sans appeler onUpdate (recalcul après le chargement
      // des images), la découpe resterait alors sur « fermé »
      gsap.ticker.add(followLid);
      undo.push(() => { gsap.ticker.remove(followLid); bac.style.clipPath = ''; });
      let shown = {};
      const render = t => {
        followLid();
        const playing = t >= T.play;
        const track = t >= T.last ? 2 : t >= T.next ? 1 : 0;
        const step = t < T.step2 ? 1 : t < T.step3 ? 2 : t < T.step4 ? 3 : 4;
        if (shown.playing !== playing) screen.classList.toggle('is-playing', playing);
        if (shown.track !== track) tracks.forEach((el, i) => el.classList.toggle('is-on', i === track));
        if (shown.step !== step) steps.forEach((el, i) => el.classList.toggle('is-active', i + 1 === step));
        const pick = list => list.reduce((txt, [at, v]) => (t >= at ? v : txt), '');
        setCall(callL, pick(chipAt.l));
        setCall(callR, pick(chipAt.r));
        shown = { playing, track, step };
      };
      // Place libre à côté du boîtier pour les étiquettes (le bord de l'écran sur téléphone, la colonne sur ordinateur)
      const prod = q('.znp-pl__prod'), stage = q('.znp-pl__stage');
      const fitCalls = () => {
        const p = prod.getBoundingClientRect(), s = stage.getBoundingClientRect();
        const lo = small ? 6 : s.left, hi = small ? document.documentElement.clientWidth - 6 : s.right;
        prod.style.setProperty('--reach', Math.round(Math.max(58, Math.min(p.left - lo, hi - p.right, 170))) + 'px');
      };
      fitCalls();
      ScrollTrigger.addEventListener('refresh', fitCalls);
      undo.push(() => ScrollTrigger.removeEventListener('refresh', fitCalls));
      pl.classList.add('is-live');
      screen.classList.remove('is-playing');
      gsap.set(slide, { xPercent: 0, yPercent: 35.44 }); // fermé : l'écran descend sur le bac (course mesurée sur la photo studio)
      gsap.set($$('.znp-pl__tap i, .znp-pl__tap em', pl), { autoAlpha: 0 });
      render(0);

      // un appui = le point du doigt s'allume et une onde part ; n appuis à la suite
      const taps = (tl, el, n, at) => {
        const rings = $$('i', el), dot = el.querySelector('em');
        tl.fromTo(dot, { autoAlpha: 0, scale: 0.5 }, { autoAlpha: 1, scale: 1, duration: 0.12, immediateRender: false }, at);
        for (let k = 0; k < n; k++) tl.fromTo(rings[k], { autoAlpha: 0.95, scale: 0.25 }, { autoAlpha: 0, scale: 1.6, duration: 0.4, immediateRender: false }, at + 0.06 + k * 0.2);
        tl.to(dot, { autoAlpha: 0, duration: 0.15 }, at + 0.25 + n * 0.2);
      };
      const ripple = (tl, el, at) => tl.fromTo(el, { autoAlpha: 0.9, scale: 0.35 }, { autoAlpha: 0, scale: 1.25, duration: 0.5, immediateRender: false }, at);

      const plHead = () => { const h = document.querySelector('.znp-head'); return h ? h.offsetHeight : 0; };
      const tl = gsap.timeline({
        defaults: { ease: 'none' },
        onUpdate: () => render(tl.time()),
        scrollTrigger: { trigger: pl, start: () => 'top ' + plHead(), end: () => '+=' + Math.round(window.innerHeight * (small ? 2.8 : 3.2)), pin: q('.znp-pl__pin'), scrub: 0.6, invalidateOnRefresh: true, toggleClass: { targets: document.body, className: 'is-demo' } }
      });
      ripple(tl, q('.znp-pl__ripple--btn'), 0.75);
      ripple(tl, q('.znp-pl__ripple--next'), 2.35);
      tl.fromTo(q('.znp-pl__btn'), { scale: 1 }, { scale: 0.92, duration: 0.12, yoyo: true, repeat: 1, immediateRender: false }, 0.8)
        .to(slide, { xPercent: 0, yPercent: 0, duration: 1.5, ease: 'power2.inOut' }, 3.7)
        .fromTo(q('.znp-pl__glow'), { '--glow': 1 }, { '--glow': 1.6, duration: 1.5 }, 3.7)
        .to(q('.znp-pl__chip--sound'), { autoAlpha: 1, y: -6, duration: 0.3 }, 5.0)
        .to(q('.znp-pl__chip--sound'), { autoAlpha: 0, duration: 0.3 }, 6.1);
      // l'étiquette apparaît et sa flèche file jusqu'à l'écouteur, au moment du premier appui de ce côté
      const callIn = (el, at) => {
        if (!el) return;
        tl.to(el, { autoAlpha: 1, duration: 0.2 }, at)
          .fromTo(el.querySelector('.znp-pl__lead'), { scaleX: 0 }, { scaleX: 1, duration: 0.35, ease: 'power2.out', immediateRender: false }, at);
      };
      if (tapL && tapR) {
        taps(tl, tapL, 1, 6.6);
        callIn(callL, 6.45);
        taps(tl, tapR, 2, 7.4);
        callIn(callR, 7.25);
        taps(tl, tapL, 2, 8.3);
        taps(tl, tapR, 3, 9.1);
      }
      tl.to(q('.znp-pl__row'), { xPercent: -10, duration: 10.6 }, 0)
        .to({}, { duration: 0.6 }, 10);
    }

    // 0 quater. Traduction IA : l'écran « assistant IA » rejoue la vidéo réelle au défilement.
    // Écoute → vous parlez (FR), il affiche l'espagnol → l'interlocuteur répond (ES), il affiche le français → question à l'IA.
    const tr = document.querySelector('[data-tr]');
    if (tr && window.znpIa) {
      const ia = tr.querySelector('[data-ia]');
      const steps = $$('.znp-pl__step', tr);
      const bubbles = $$('.znp-tr__bubble', tr);
      let texts = [];
      try { texts = JSON.parse(tr.querySelector('[data-tr-texts]').textContent || '""').split('|'); } catch (e) { /* écran vide */ }
      // [début, fin] de chaque réplique affichée sur l'écran, en temps de frise
      const lines = [{ a: 3.4, b: 4.6, t: texts[0] }, { a: 6.4, b: 7.6, t: texts[1] }, { a: 9.0, b: 10.2, t: texts[2] }];
      const thinking = [[2.8, 3.4], [5.8, 6.4], [8.5, 9.0]];
      let step = 0;
      const render = t => {
        const s = t < 1.8 ? 1 : t < 5 ? 2 : t < 8 ? 3 : 4;
        if (s !== step) { steps.forEach((el, i) => el.classList.toggle('is-active', i + 1 === s)); step = s; }
        const cur = [...lines].reverse().find(l => t >= l.a);
        if (thinking.some(([a, b]) => t >= a && t < b)) znpIa.set(ia, 'pensee');
        else if (cur && t < cur.b + 1.1) znpIa.set(ia, 'parle', cur.t, (t - cur.a) / (cur.b - cur.a));
        else znpIa.set(ia, 'ecoute');
      };
      tr.classList.add('is-live');
      gsap.set(bubbles, { autoAlpha: 0, y: 14 });
      render(0);
      const trHead = () => { const h = document.querySelector('.znp-head'); return h ? h.offsetHeight : 0; };
      const tl = gsap.timeline({
        defaults: { ease: 'none' },
        onUpdate: () => render(tl.time()),
        scrollTrigger: { trigger: tr, start: () => 'top ' + trHead(), end: () => '+=' + Math.round(window.innerHeight * (small ? 2.6 : 3)), pin: tr.querySelector('.znp-pl__pin'), scrub: 0.6, invalidateOnRefresh: true, toggleClass: { targets: document.body, className: 'is-demo' } }
      });
      [[1.9, 5.0], [5.1, 8.0], [8.1, 0]].forEach(([a, b], i) => {
        tl.to(bubbles[i], { autoAlpha: 1, y: 0, duration: 0.35, ease: 'power2.out' }, a);
        if (b) tl.to(bubbles[i], { autoAlpha: 0, y: -10, duration: 0.3 }, b); // la dernière question reste affichée
      });
      tl.to({}, { duration: 0.6 }, 10.4);
    }

    // 0. Header animé : le vrai boîtier s'ouvre à l'arrivée, puis au défilement (moment fort, façon page produit Apple)
    const intro = document.querySelector('[data-intro]');
    if (intro) {
      const pin = intro.querySelector('.znp-intro__pin');
      const stage = intro.querySelector('.znp-intro__stage');
      const prod = intro.querySelector('.znp-intro__prod');
      const txt = intro.querySelector('.znp-intro__txt');
      const a = intro.querySelector('.znp-intro__a'), b = intro.querySelector('.znp-intro__b');
      const screen = intro.querySelector('.znp-intro__screen');
      const calls = $$('.znp-intro__call', intro);
      const hint = intro.querySelector('.znp-intro__hint');
      // Course réelle de l'écran, mesurée sur la photo : 34,9 % de la hauteur vers le bas, 9,67 % vers la gauche (axe du boîtier incliné)
      const SHUT = { xPercent: -9.67, yPercent: 34.9 };
      const TEASE = 0.62; // part encore fermée après l'ouverture d'arrivée
      const lines = intro.querySelector('.znp-h1 .znp-line-mask') ? $$('.znp-h1 .znp-line-mask > span', intro) : maskLines($$('.znp-h1 > span', intro));
      gsap.set(a, SHUT);
      gsap.set(calls, { autoAlpha: 0, x: small ? 0 : -12, y: small ? 8 : 0 });

      // Arrivée : le boîtier fermé se pose, l'écran s'allume, puis il commence à s'ouvrir
      const tl = gsap.timeline({ defaults: { ease: EASE }, delay: 0.1 });
      tl.from(prod, { autoAlpha: 0, y: small ? 40 : 70, scale: 0.92, duration: 1.3 }, 0)
        .fromTo(intro.querySelector('.znp-intro__glow'), { '--glow': 0 }, { '--glow': 1, duration: 1.8, ease: 'power2.out' }, 0.2)
        .fromTo(screen, { filter: 'brightness(.28) drop-shadow(0 24px 30px rgba(0,0,0,.75))' }, { filter: 'brightness(1) drop-shadow(0 24px 30px rgba(0,0,0,.75))', duration: 0.9, ease: 'power2.out', clearProps: 'filter' }, 0.7)
        .to(a, { xPercent: SHUT.xPercent * TEASE, yPercent: SHUT.yPercent * TEASE, duration: 1.3, ease: 'power3.inOut' }, 1.2)
        .from(intro.querySelector('.znp-label'), { autoAlpha: 0, y: 10, duration: 0.6 }, 0.15)
        .from(lines, { yPercent: 115, duration: 1.1, stagger: 0.12 }, 0.25)
        .from(intro.querySelector('.znp-lead'), { autoAlpha: 0, y: 18, duration: 0.8 }, 0.7)
        .from($$('.znp-hero__btns > *', intro), { autoAlpha: 0, y: 16, duration: 0.7, stagger: 0.08 }, 0.85);
      if (hint) tl.from(hint, { autoAlpha: 0, y: -8, duration: 0.8 }, 1.8);

      // Défilement : le texte s'efface, le boîtier vient au centre et s'ouvre jusqu'au bout, les légendes apparaissent
      // Mesures sans transformation (offset*), pour rester justes si la page est redimensionnée en cours de défilement
      const grid = stage.offsetParent;
      const toCenter = () => ({
        x: small ? 0 : pin.clientWidth / 2 - (grid.offsetLeft + stage.offsetLeft + stage.offsetWidth / 2),
        // centre de la zone visible sous l'en-tête fixe (le bloc épinglé démarre en haut de l'écran)
        y: (headH + window.innerHeight) / 2 - (grid.offsetTop + stage.offsetTop + stage.offsetHeight / 2)
      });
      const head = document.querySelector('.znp-head');
      let headH = head ? head.offsetHeight : 0;
      ScrollTrigger.addEventListener('refreshInit', () => { headH = head ? head.offsetHeight : 0; });
      const st = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: { trigger: intro, start: 'top top', end: () => '+=' + Math.round(window.innerHeight * (small ? 1.3 : 1.7)), pin: pin, scrub: 0.6, invalidateOnRefresh: true }
      });
      st.to(txt, { autoAlpha: 0, y: small ? -60 : -40, duration: 0.22 }, 0)
        .to(stage, { x: () => toCenter().x, y: () => toCenter().y, scale: small ? 1.3 : 1, duration: 0.4, ease: 'power1.inOut' }, 0)
        .to(b, { xPercent: -SHUT.xPercent * TEASE, yPercent: -SHUT.yPercent * TEASE, duration: 0.5, ease: 'power1.inOut' }, 0.12)
        .to(intro.querySelector('.znp-intro__shadow'), { scaleX: 1.12, duration: 0.5 }, 0.12)
        .to(calls[0] || {}, { autoAlpha: 1, x: 0, y: 0, duration: 0.14 }, 0.45)
        .to(calls[1] || {}, { autoAlpha: 1, x: 0, y: 0, duration: 0.14 }, 0.62)
        .to({}, { duration: 0.24 });
      if (hint) st.to(hint, { autoAlpha: 0, duration: 0.08 }, 0);
    }

    // 1. Header photo
    const hero = document.querySelector('.znp-hero');
    if (hero) {
      const lines = hero.querySelector('.znp-h1 .znp-line-mask') ? $$('.znp-h1 .znp-line-mask > span', hero) : maskLines($$('.znp-h1 > span', hero));
      const media = hero.querySelector('.znp-hero__media');
      const img = media && media.querySelector('img');
      const tl = gsap.timeline({ defaults: { ease: EASE }, scrollTrigger: (intro || scene) ? { trigger: hero, start: 'top 78%', once: true } : undefined });
      tl.from(hero.querySelector('.znp-label'), { autoAlpha: 0, y: 10, duration: 0.6 }, 0)
        .from(lines, { yPercent: 115, duration: 1.1, stagger: 0.12 }, 0.1)
        .from(hero.querySelector('.znp-lead'), { autoAlpha: 0, y: 18, duration: 0.8 }, 0.55)
        .from($$('.znp-hero__btns > *', hero), { autoAlpha: 0, y: 16, duration: 0.7, stagger: 0.08 }, 0.7)
        .from($$('.znp-hero__pts li', hero), { autoAlpha: 0, duration: 0.6, stagger: 0.06 }, 0.85);
      if (img) {
        tl.fromTo(img, { clipPath: 'inset(12% 12% 12% 12% round 28px)', scale: 1.08 }, { clipPath: 'inset(0% 0% 0% 0% round 28px)', scale: 1, duration: 1.4, clearProps: 'clipPath' }, small ? 0.5 : 0.2)
          .fromTo(media, { '--glow': 0 }, { '--glow': 1, duration: 1.8, ease: 'power2.out' }, '<0.3');
      }
    }
    release();

    // 2. Titres de section : révélation ligne par ligne (blanc puis gris)
    $$('.znp-sec__head, .znp-cta .wrap').forEach(head => {
      const st = { trigger: head, start: 'top 85%', once: true };
      const kick = head.querySelector('.znp-kick');
      const lead = head.querySelector('.znp-lead');
      if (kick) gsap.from(kick, { autoAlpha: 0, x: -14, duration: 0.7, ease: EASE, scrollTrigger: st });
      const h2 = head.querySelector('.znp-h2');
      if (h2 && hasSplit) {
        SplitText.create(h2, {
          type: 'lines', mask: 'lines', linesClass: 'znp-line', autoSplit: true,
          onSplit: self => gsap.from(self.lines, { yPercent: 115, duration: 1, stagger: 0.1, ease: EASE, scrollTrigger: st })
        });
      }
      if (lead) gsap.from(lead, { autoAlpha: 0, y: 16, duration: 0.8, delay: 0.25, ease: EASE, scrollTrigger: st });
    });

    // Musique, appels : la photo se dévoile, les vrais écrans du boîtier arrivent puis flottent légèrement au défilement
    $$('[data-use]').forEach(sec => {
      const photo = sec.querySelector('.znp-use__photo');
      const screens = $$('.znp-use__screen', sec);
      const pts = $$('.znp-use__pts li', sec);
      const tl = gsap.timeline({ defaults: { ease: EASE }, scrollTrigger: { trigger: sec.querySelector('.znp-use__grid'), start: 'top 78%', once: true } });
      if (photo) tl.fromTo(photo, { clipPath: 'inset(10% 10% 10% 10% round 22px)' }, { clipPath: 'inset(0% 0% 0% 0% round 22px)', duration: 1.4, clearProps: 'clipPath' }, 0)
        .from(photo.querySelector('img'), { scale: 1.12, duration: 1.8 }, 0);
      if (screens.length) tl.from(screens, { autoAlpha: 0, y: rise * 1.4, rotation: (i) => (i ? 4 : -4), duration: 1.1, stagger: 0.14 }, 0.45);
      if (pts.length) tl.from(pts, { autoAlpha: 0, y: 18, duration: 0.8, stagger: 0.07 }, 0.35);
      // le flottement s'applique au conteneur, pour ne pas se battre avec l'arrivée des écrans
      if (screens.length && !small) gsap.fromTo(sec.querySelector('.znp-use__screens'), { y: 40 }, { y: -50, ease: 'none', scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    // 3. Chiffres clés : une liste, donc un léger décalage
    const stats = document.querySelector('.znp-stats__grid');
    if (stats) gsap.from(stats.children, { autoAlpha: 0, y: rise * 0.6, duration: 0.8, stagger: 0.08, ease: EASE, scrollTrigger: { trigger: stats, start: 'top 88%', once: true } });

    // 4. Carrousels de visuels : onglets puis visuels de l'onglet ouvert
    $$('.znp-gal').forEach(sec => {
      const st = { trigger: sec.querySelector('.znp-tabs, .znp-panel'), start: 'top 85%', once: true };
      const tabs = $$('.znp-tabs button', sec);
      if (tabs.length) gsap.from(tabs, { autoAlpha: 0, y: 10, duration: 0.5, stagger: 0.03, ease: 'power2.out', scrollTrigger: st });
      const panel = sec.querySelector('.znp-panel:not([hidden])');
      if (panel) gsap.from($$('.znp-slide', panel), { autoAlpha: 0, y: rise, scale: 0.97, duration: 1, stagger: 0.09, ease: EASE, scrollTrigger: { ...st, trigger: panel } });
    });

    // 5. Le boîtier : moment fort n°2, les fonctions partent du produit
    const stage = document.querySelector('.znp-all__stage');
    if (stage) {
      const prod = stage.querySelector('.znp-all__prod');
      const tl = gsap.timeline({ defaults: { ease: EASE }, scrollTrigger: { trigger: stage, start: 'top 78%', once: true } });
      if (prod) {
        tl.from($$('.znp-all__shot', prod), { autoAlpha: 0, y: rise * 1.6, scale: 0.9, duration: 1.3, stagger: 0.16 }, 0)
          .fromTo(prod, { '--glow': 0 }, { '--glow': 1, duration: 1.6, ease: 'power2.out' }, 0.2);
        // Le dos arrive juste après la face, puis le cercle désigne le haut-parleur
        const spk = prod.querySelector('.znp-all__spk'), cap = prod.querySelector('.znp-all__cap');
        if (spk) tl.from(spk, { scale: 0, autoAlpha: 0, duration: 0.7, ease: 'back.out(2)' }, 1);
        if (cap) tl.from(cap, { autoAlpha: 0, y: 8, duration: 0.6 }, 1.1);
      }
      const [left, right] = $$('.znp-all__col', stage);
      const fx = col => $$('.znp-fx', col);
      if (small) tl.from([...fx(left), ...fx(right)], { autoAlpha: 0, y: 18, duration: 0.7, stagger: 0.05 }, 0.45);
      else {
        if (left) tl.from(fx(left), { autoAlpha: 0, x: 48, duration: 0.9, stagger: 0.08 }, 0.45);
        if (right) tl.from(fx(right), { autoAlpha: 0, x: -48, duration: 0.9, stagger: 0.08 }, 0.45);
      }
    }

    // Mise en situation : grande photo, elle se déroule de haut en bas (le haut est la partie déjà à l'écran) et l'image se pose
    $$('.znp-photo__fig').forEach(fig => {
      gsap.timeline({ scrollTrigger: { trigger: fig, start: 'top 80%', once: true } })
        .fromTo(fig, { clipPath: 'inset(0% 0% 100% 0% round 22px)' }, { clipPath: 'inset(0% 0% 0% 0% round 22px)', duration: 1.3, ease: 'expo.inOut', clearProps: 'clipPath' }, 0)
        .from(fig.querySelector('img'), { scale: 1.14, duration: 1.8, ease: 'power3.out', clearProps: 'transform' }, 0.25);
    });

    // Photos réelles : chaque tuile se dévoile par le bas, la grande d'abord
    const reel = document.querySelector('.znp-reel__grid');
    if (reel) gsap.fromTo($$('.znp-reel__item', reel), { clipPath: 'inset(100% 0% 0% 0% round 22px)' }, { clipPath: 'inset(0% 0% 0% 0% round 22px)', duration: 1.1, stagger: 0.1, ease: 'expo.inOut', clearProps: 'clipPath', scrollTrigger: { trigger: reel, start: 'top 82%', once: true } });

    // Vidéos créateurs : les vignettes arrivent l'une après l'autre
    const tt = document.querySelector('.znp-tt__track');
    if (tt) gsap.from(tt.children, { autoAlpha: 0, y: rise, duration: 0.9, stagger: 0.07, ease: EASE, scrollTrigger: { trigger: tt, start: 'top 85%', once: true } });

    // Carte des langues : les pays s'allument, puis les points apparaissent dans le désordre
    const map = document.querySelector('[data-map]');
    // (carte regroupée par langue : ce sont les langues qui défilent, assets/znp.js ; pas d'arrivée des 122 points)
    if (map && !map.classList.contains('is-grouped')) {
      const mst = { trigger: map.querySelector('.znp-map__frame'), start: 'top 80%', once: true };
      gsap.from(map.querySelectorAll('.znp-map__svg path.on'), { fill: '#141414', duration: 1.2, stagger: { amount: 0.8, from: 'random' }, ease: 'power1.out', scrollTrigger: mst });
      gsap.from(map.querySelectorAll('.znp-map__pin'), { scale: 0, autoAlpha: 0, duration: 0.5, stagger: { amount: 1.4, from: 'random' }, ease: 'back.out(2)', scrollTrigger: mst });
    }
    if (map) {
      gsap.from(map.querySelectorAll('.znp-map__stats dt'), { textContent: 0, snap: { textContent: 1 }, duration: 1.4, ease: 'power2.out', scrollTrigger: { trigger: map, start: 'top 75%', once: true } });
    }

    // Avis clients : une liste, donc un léger décalage
    const avis = document.querySelector('.znp-avis__grid');
    if (avis) gsap.from(avis.children, { autoAlpha: 0, y: rise * 0.6, duration: 0.8, stagger: 0.08, ease: EASE, scrollTrigger: { trigger: avis, start: 'top 85%', once: true } });
    const shots = document.querySelector('.znp-avis__photos');
    if (shots) gsap.from(shots.children, { autoAlpha: 0, y: 20, duration: 0.7, stagger: 0.06, ease: EASE, scrollTrigger: { trigger: shots, start: 'top 90%', once: true } });

    // Caractéristiques : les visuels, puis les groupes de la fiche
    const cv = document.querySelector('.znp-carac__visuals');
    if (cv) gsap.from(cv.children, { autoAlpha: 0, y: rise, duration: 0.9, stagger: 0.08, ease: EASE, scrollTrigger: { trigger: cv, start: 'top 85%', once: true } });
    const cs = document.querySelector('.znp-carac__specs');
    if (cs) gsap.from(cs.children, { autoAlpha: 0, y: 18, duration: 0.7, stagger: 0.06, ease: EASE, scrollTrigger: { trigger: cs, start: 'top 85%', once: true } });

    // 6. Achat : galerie puis informations
    $$('.znp-buy__grid').forEach(buy => {
      const tl = gsap.timeline({ defaults: { ease: EASE }, scrollTrigger: { trigger: buy, start: 'top 80%', once: true } });
      const media = buy.querySelector('.znp-buy__media');
      if (media) tl.from(media, { autoAlpha: 0, y: rise, duration: 1 }, 0);
      tl.from($$('.znp-buy__info > *', buy), { autoAlpha: 0, y: 16, duration: 0.8, stagger: 0.06 }, 0.15);
    });

    // 7. FAQ et appel final
    const faq = document.querySelector('.znp-faq__list');
    if (faq) gsap.from(faq.children, { autoAlpha: 0, y: 14, duration: 0.7, stagger: 0.06, ease: EASE, scrollTrigger: { trigger: faq, start: 'top 88%', once: true } });
    const cta = document.querySelector('.znp-cta');
    // fromTo : la transition CSS du bouton (transform) faussait la position d'arrivée lue par un simple from()
    if (cta) gsap.fromTo($$('.btn, .znp-cta__img', cta), { autoAlpha: 0, y: rise }, { autoAlpha: 1, y: 0, duration: 1, stagger: 0.12, delay: 0.3, ease: EASE, scrollTrigger: { trigger: cta, start: 'top 75%', once: true } });
    return () => undo.forEach(f => f());
  });

  // Les positions dépendent de la police : on recalcule une fois Montserrat chargée
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => ScrollTrigger.refresh());
})();
